export const list = {
  job_name: {
    name: '职位',
    key: 'job_name',
  },
  users_count: {
    name: '人数',
    key: 'users_count'
  },
};
